import { Controller } from "stimulus";
import { FocusTrap } from 'shared/assets/javascript/accessibility/focusTrap.js';

export default class extends Controller {
  static targets = ["toggle", "close", "modal"];

  get headerBookingToggle() {
    return document.querySelector('.resort-booking-sidebar__toggle');
  }

  get footerBookingToggle() {
    return document.querySelector('.footer-bar .resort-booking-sidebar__toggle');
  }

  get closeToggle() {
    return document.querySelector('.resort-booking-sidebar__close');
  }

  initialize() {
    this.state = {
      active: false,
    };
  }

  connect() {
    document.addEventListener('click', this.checkOutsideClick.bind(this));
    this.headerBookingToggle.addEventListener('click', this.toggleActive.bind(this));
    this.footerBookingToggle.addEventListener('click', this.toggleActive.bind(this));
    this.element.addEventListener('keyup', this.handleKeyUp.bind(this));

    this.modal = this.element
    this.modalToggle = this.headerBookingToggle
    this.footerModalToggle = this.footerBookingToggle
    this.focusTrapInstance = new FocusTrap([this.modalToggle, this.modal])
  }

  disconnect() {
    this.document.removeEventListener('click', this.checkOutsideClick.bind(this));
    this.headerBookingToggle.removeEventListener('click', this.toggleActive.bind(this));
    this.footerBookingToggle.removeEventListener('click', this.toggleActive.bind(this));
    this.element.removeEventListener('keyup', this.handleKeyUp.bind(this));
  }

  toggleActive(event) {
    event.preventDefault();
    event.stopPropagation();
    this.state.active ? this.clearActive() : this.setActive();
  }

  setActive() {
    this.state.active = true;
    this.element.classList.add('is-active');
    this.element.setAttribute('aria-hidden', 'false');
    this.focusTrapInstance.set();
    this.closeToggle.focus();
  }

  clearActive() {
    this.state.active = false;
    this.element.classList.remove('is-active');
    this.focusTrapInstance.unset();
  }

  checkOutsideClick(event) {
    if (!this.state.active) return;
    const module = this.element;
    const target = event.target;
    const isWithinModule = module.contains(target);
    if (!isWithinModule) this.clearActive();
  }

  handleKeyUp(event) {
    if ((event.keyCode == 27) && this.state.active) {
      this.clearActive();
    }
  }
}

